import React from 'react'

const SettingsIcon = (props: any) => {
  const height = props.height || 20
  const width = props.width || 20
  return (
    <svg width={width} height={height} viewBox="0 0 17 16" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(1 .5)" stroke="#202020" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="7.5" cy="7.5" r="2.25"/>
      <path d="M13.305 9h.945a.75.75 0 0 0 .75-.75v-1.5a.75.75 0 0 0-.75-.75h-.945v-.105a6.127 6.127 0 0 0-.615-1.44l.668-.667a.75.75 0 0 0 0-1.058L12.27 1.665a.75.75 0 0 0-1.057 0l-.668.667A6 6 0 0 0 9 1.688V.75A.75.75 0 0 0 8.25 0h-1.5A.75.75 0 0 0 6 .75v.938a6 6 0 0 0-1.545.645l-.667-.668a.75.75 0 0 0-1.058 0L1.665 2.73a.75.75 0 0 0 0 1.058l.667.667a6.128 6.128 0 0 0-.614 1.44V6H.75a.75.75 0 0 0-.75.75v1.5c0 .414.336.75.75.75h.945v.105c.143.504.35.988.615 1.44l-.645.705a.75.75 0 0 0 0 1.057l1.065 1.066a.75.75 0 0 0 1.058 0l.667-.668A6 6 0 0 0 6 13.35v.9c0 .414.336.75.75.75h1.5a.75.75 0 0 0 .75-.75v-.938a6 6 0 0 0 1.545-.644l.668.667a.75.75 0 0 0 1.057 0l1.065-1.065a.75.75 0 0 0 0-1.057l-.668-.668c.266-.452.473-.936.616-1.44L13.305 9z"/>
    </g>
    </svg>
    )
}

export default SettingsIcon





